var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.widget ? _c('div', {
    staticClass: "widget-form-container"
  }, [_vm._l(_vm.widget.variants, function (variant, idx) {
    return _c('div', {
      key: idx,
      staticClass: "section-container"
    }, [_c('substrate-mount', [_c('div', {
      staticClass: "attachment-input-container"
    }, [_c('input-price', {
      ref: "amountFrom",
      refInFor: true,
      attrs: {
        "input-id": "variant.amountFrom.".concat(idx),
        "input-name": "".concat(_vm.$t('showing.for.donation.from'), ", ").concat(_vm.currency.sign),
        "min-value": 0,
        "currency": _vm.currency,
        "error": _vm.isRepeatedValues(idx),
        "attachment": ""
      },
      on: {
        "change": function change($event) {
          variant.amountFrom = $event;
        }
      },
      model: {
        value: variant.amountFrom,
        callback: function callback($$v) {
          _vm.$set(variant, "amountFrom", $$v);
        },
        expression: "variant.amountFrom"
      }
    }), _c('attachment-image', {
      attrs: {
        "link": variant.attachment.link,
        "input-id": "variant.attachment.".concat(idx),
        "type": "secondary",
        "composite": ""
      },
      on: {
        "loading": _vm.onImageLoading,
        "uploaded": function uploaded(data) {
          return variant.attachment.setData(data);
        },
        "reset": function reset($event) {
          return variant.attachment.reset();
        }
      }
    })], 1), !_vm.isDesktop && _vm.isSeveralVariantsAvailable ? _c('form-delete-icon', {
      on: {
        "click": function click($event) {
          return _vm.onRemoveVariant(idx);
        }
      }
    }) : _vm._e()], 1), _vm.isDesktop && _vm.isSeveralVariantsAvailable ? _c('form-delete-icon', {
      on: {
        "click": function click($event) {
          return _vm.onRemoveVariant(idx);
        }
      }
    }) : _vm._e()], 1);
  }), !_vm.isExceededVariantsCount ? _c('div', {
    staticClass: "panel-container"
  }, [_c('capusta-panel', {
    attrs: {
      "icon": "circle-plus",
      "description": _vm.$t('add.variant')
    },
    on: {
      "click": _vm.onAddVariant
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.proceed')) + " ")])], 1)], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }